import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, TextField, Button, Typography } from '@mui/material';
import './ForgetPassword.css';
import logo from './assets/Logo.png';

function ForgetPassword() {
  const navigate = useNavigate();
  const [postalCode, setPostalCode] = useState('');
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');

  const handleCheckInfo = async () => {
    try {
      const response = await fetch("https://carcure.ca/backend/check-client-info", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ postalCode, phone })
      });
      const data = await response.json();
      if (response.ok && data.found) {
        navigate("/reset-password", { state: { postalCode, phone } });
      } else {
        setError("Client not found. Please send your request for password recovery to info@carcure.ca.");
      }
    } catch (err) {
      setError("Server error. Please try again later.");
    }
  };

  return (
    <div className="content-container">
      <div className="top-text-box">
        <Typography variant="h4" className="top-title">Forgot Password</Typography>
      </div>
      <div className="form-container">
        <div className="modal-header">
          <img src={logo} alt="Logo" className="modal-logo" />
          <button className="close-button" onClick={() => navigate("/login")}>×</button>
        </div>
        {error && (
          <Typography color="error" align="center" style={{ marginBottom: '10px' }}>
            {error}
          </Typography>
        )}
        <TextField 
          fullWidth 
          label="Postal Code" 
          value={postalCode} 
          onChange={(e) => setPostalCode(e.target.value)}
          margin="normal"
          className="custom-input"
        />
        <TextField 
          fullWidth 
          label="Phone Number" 
          value={phone} 
          onChange={(e) => setPhone(e.target.value)}
          margin="normal"
          className="custom-input"
        />
        <Button 
          variant="contained" 
          color="primary" 
          fullWidth 
          onClick={handleCheckInfo}
          className="custom-button"
          style={{ marginTop: '20px' }}
        >
          Check Information
        </Button>
        {error && (
          <Button 
            variant="outlined" 
            color="secondary" 
            fullWidth 
            onClick={() => navigate("/login")}
            style={{ marginTop: '10px' }}
          >
            Close
          </Button>
        )}
      </div>
    </div>
  );
}

export default ForgetPassword;
